import { render, staticRenderFns } from "./UniqueChoice.vue?vue&type=template&id=011366dc&scoped=true"
import script from "./UniqueChoice.vue?vue&type=script&lang=js"
export * from "./UniqueChoice.vue?vue&type=script&lang=js"
import style0 from "./UniqueChoice.vue?vue&type=style&index=0&id=011366dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011366dc",
  null
  
)

export default component.exports